import React from 'react';
import SvgIcon from './SvgIcon';

const LenelLogo = props => (
    <SvgIcon viewBox="0 0 1036.09 332.7" aria-label="Lenel" {...props}>
        <path
            fill="#4e84c4"
            d="M832.06 160.54c10.71 3.54 25 10.15 25 26.69 0 17.28-18.11 29.35-44 29.35-16.28 0-32.22-5.14-43.71-14.1l-1.16-.9 14.13-13.19.78.59c8.75 6.61 20.12 10.55 30.4 10.55 12.28 0 19.62-4.1 19.62-11s-6.89-9.1-17.31-12.6L799 170.21c-16.33-5.38-25-14.46-25-26.21 0-15.91 17.74-27.9 41.27-27.9 14.08 0 27.76 4.49 37.52 12.32l1.11.88-12.57 12.31-.79-.54a43.37 43.37 0 0 0-25.27-7.92c-10.79 0-17.5 3.78-17.5 9.87 0 6.33 8.06 8.94 17.38 12l.77.24 16.1 5.35m80.06 36.3c-4.75 0-10.72.33-15.78.67 22.73-19.2 39.74-35.38 39.74-51.57 0-18.15-14.88-29.88-37.91-29.88-14.82 0-25.78 4.28-37.84 14.78l-1.16 1 13.64 10.83.73-.66c7.61-6.84 14.56-10 21.86-10 11.45 0 18 5.4 18 14.82 0 13.45-19.76 27.29-52 52.49l-.48.38v14h80.79v-16.93Z"
        />
        <path
            d="M666.8 213.61v-94.37h21.66V196h63.92v17.62Zm-310.32 0V196h-63.91v-76.76H270.9v94.37Zm95.7 0V196h-63.47v-23.2h32v-16.3h-32V136h62.43v-16.76H367v94.37Zm29.63 0v-61l64.1 61h14.79v-94.37h-19.37v60.07L477 119.24h-14.77v94.37Zm174.5 0V196h-63.46v-23.2h32v-16.3h-32V136h62.43v-16.76h-84.1v94.37Zm96.07-56.13a11.17 11.17 0 1 0-11.17 11.17 11.17 11.17 0 0 0 11.17-11.17m-587.74 22.03a9.31 9.31 0 0 0-2.75-6.62l-2.06-2.06a25 25 0 0 1 0-35.41L187.22 108l-8.67-8.66a17.15 17.15 0 0 0-24.33 0l-54.79 54.82a17.18 17.18 0 0 0 0 24.34l35 35 27.39-27.39a9.31 9.31 0 0 0 2.77-6.64"
            fill="#034999"
        />
        <path
            fill="#4e84c4"
            d="m233.34 154.16-35.05-35-27.38 27.34a9.34 9.34 0 0 0 0 13.26l2.06 2.06a25 25 0 0 1 0 35.41l-27.39 27.39 8.67 8.66a17.2 17.2 0 0 0 24.33 0l54.79-54.78a17.18 17.18 0 0 0 0-24.34"
        />
    </SvgIcon>
);

LenelLogo.displayName = 'LenelLogoIcon';

export default LenelLogo;
